import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import * as R from 'ramda';
import { orderSelectors, orderTypes, orderActions } from '../../../../redux/order';
import { CommentModal } from '../../../_Common/Modals';
import { workflowStatusSelectors } from '../../../../redux/workflowStatus';
import { applicationSelectors } from '../../../../redux/application';

const OrderStatusCommentModalContainer = props => <CommentModal {...props} />;

OrderStatusCommentModalContainer.propTypes = {
  orderId: PropTypes.number.isRequired,
  nextStatusCode: PropTypes.string.isRequired,
};

const mapStateToProps = (state, { orderId, nextStatusCode }) => {
  const order = orderSelectors.getCurrentOrder(state);
  const getStatusNameByCode = R.compose(
    R.propOr('', 'Name'),
    statusCode => workflowStatusSelectors.getById(state)[statusCode],
  );
  const currentStatusName = getStatusNameByCode(order.Status);
  const nextStatusName = getStatusNameByCode(nextStatusCode);

  return {
    title: I18n.t('orderStatusModal.title', { currentStatusName, nextStatusName }),
    isLoading: applicationSelectors.isLoading(state, orderTypes.UPDATE_ORDER_STATUS.REQUEST),
    label: I18n.t('orderStatusModal.label'),
  };
};

const mapDispatchToProps = (dispatch, { orderId, nextStatusCode }) => ({
  onConfirm: Comment =>
    dispatch(orderActions.updateStatus.request({ WorkflowStatusCode: nextStatusCode, Comment, orderId })),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderStatusCommentModalContainer);
